import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import CuadroDatos from '../UI/CuadroDatos.js';
import TablaDatos from '../UI/TablaDatos.js';
import useGetListaURL from '../../hooks/useGetListaURL.js';
import styles from './MaximosGoleadores.module.css';
import { ApellidoNombrePuesto } from '../funciones/FuncionesPersona.js';

const MaximosGoleadores = ({ club }) => {
  const [goleadores, setGoleadores] = useState([]);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    if (club && club.id) {
      fetchData(`clubes/${club.id}/jugadores/goleadores/maximos?cantidad=20`, setGoleadores);
    } else {
      setGoleadores([]);
    }
  }, [club, fetchData]);

  return (
    <CuadroDatos titulo="Máximos goleadores" isCargando={isCargando} errores={erroresGetLista}>
      <TablaDatos
        estilo={`${styles.tablaGoleadores}`}
        lista={goleadores}
        isCargando={isCargando}
        textoVacia="No se encontraron goleadores"
      >
        <thead>
          <tr>
            <th className={`${styles.itemGoleador}`}>Jugador</th>
            <th className={`${styles.columnaCentrada}`}>Goles</th>
          </tr>
        </thead>
        <tbody className={`${styles.listaGoleadores}`}>
          {goleadores &&
            goleadores.map((goleador, index) => (
              <tr key={goleador?.id || index}>
                <td className={`${styles.itemGoleador}`}>
                  {goleador && goleador.id ? (
                    <Link
                      className={`${styles.linkGoleador}`}
                      to={`/jugador/${goleador.id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {ApellidoNombrePuesto(goleador)}
                    </Link>
                  ) : (
                    <span>{goleador ? ApellidoNombrePuesto(goleador) : ''}</span>
                  )}
                </td>
                <td className={`${styles.columnaCentrada}`}>{goleador.golesConvertidos}</td>
              </tr>
            ))}
        </tbody>
      </TablaDatos>
    </CuadroDatos>
  );
};

export default MaximosGoleadores;
